/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_EyebrowInputs */

const en_directory_search_eyebrow = /** @type {(inputs: Directory_Search_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product search`)
};

const zh_directory_search_eyebrow = /** @type {(inputs: Directory_Search_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品搜索`)
};

/**
* | output |
* | --- |
* | "Product search" |
*
* @param {Directory_Search_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_search_eyebrow = /** @type {((inputs?: Directory_Search_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_search_eyebrow(inputs)
	return zh_directory_search_eyebrow(inputs)
});
export { directory_search_eyebrow as "directory.search.eyebrow" }